import { atomWithLocalStorage } from "@/utils/jotai/atomStorage.ts";

export const displayCurrencyAtom = atomWithLocalStorage<string | undefined>("displayCurrency", undefined);
